import { getAllListCouriers } from '../api'
import { Courier } from '../../../../interfaces/Courier'

const cachedPromises: Record<string, Promise<Courier[]>> = {}

export const getCourierListCached = (onlyActive?: boolean): Promise<Courier[]> => {
  const cacheKey = onlyActive === undefined ? 'default' : String(onlyActive)

  if (!cachedPromises[cacheKey]) {
    cachedPromises[cacheKey] = getAllListCouriers(onlyActive)
      .then((response) => response.data || [])
      .catch((error) => {
        delete cachedPromises[cacheKey]
        throw error
      })
  }

  return cachedPromises[cacheKey]
}
